
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M.812.305c.195-.187.46-.293.735-.293.276 0 .54.106.735.293L5.706 3.59 9.13.305c.096-.096.21-.172.337-.224a1.077 1.077 0 011.146.211.964.964 0 01-.013 1.424L6.44 5.708c-.195.187-.46.292-.735.292-.276 0-.54-.105-.735-.292L.812 1.716a.978.978 0 01-.304-.706c0-.264.11-.518.304-.705z"}})])
          )
        }
      }
    